/**
 * Les Règles !
 * Nom du rôle : ["page:action"]
 * 
 */
const rules = {
  "extc-user": [
    "home:visit",
    "search-cases:visit",
    "case:visit"
  ],
  "extc-doss": [
    "home:visit",
    "console-cases:visit"
  ],
  "extc-mess": [
    "home:visit",
    "console-messages:visit"
  ],
  "extc-emess": [
    "message:visit",
    "message:new",
    "message:reply",
    "message:update"
  ],
  "extc-reporting": [
    "home:visit",
    "reporting:visit"
  ],
  "extc-task": [
    "home:visit",
    "console-tasks:visit",
  ],
  "extc-data": [
    "extraction:visit"
  ],
  "extc-repairs": [
    "home:visit",
    "console-repairs:visit"
  ],
  "extc-admin": [
    "search-user:visit",
    "search-customer:visit",
    "create-user:visit",
    "create-customer:visit",
    "reporting:process"
  ],
  "extc-suivigaranties": [
    "guarantee:visit",
  ],
  "extc-decisiongaranties": [
    "guarantee:choose"
  ],

  /*
    Gestion par typologie client et segments d'activités

    Typologie
    "AC": Assureur / Courtier
    "CO": Constructeur
    "LO": Loueur
    "MO": Mobilité international
    "SA": Santé

    Segments : 
    "DEP": Déplacement véhicule
    "HAB": Habitation
    "MOB": Mobilité internationnal
    "SAN": Santé
  */

  "AC-DEP": [
    "externalId:display", //Référence sinistre
    "vehicle:display",
    "holderId:display",
    "distance:display",
    "subscriber:display"
  ],
  "AC-HAB": [
    "externalId:display",
    "holderId:display",
    "distance:display",
    "subscriber:display"
  ],
  "AC-MOB": [
    "externalId:display",
    "holderId:display",
    "distance:display",
    "subscriber:display"
  ],
  "AC-SAN": [
    "holderId:display",
    "distance:display",
    "subscriber:display"
  ],

  "CO-DEP": [
    "contract:display",
    "vehicle:display"
  ],
  "CO-HAB": [
    "contract:display"
  ],
  "CO-MOB": [
    "contract:display"
  ],
  "CO-SAN": [
    "contract:display"
  ],

  "LO-DEP": [
    "contract:display",
    "depertureAgency:display",
    "vehicle:display",
    "distance:display"
  ],
  "LO-HAB": [
    "contract:display",
    "depertureAgency:display",
    "distance:display"
  ],
  "LO-MOB": [
    "contract:display",
    "depertureAgency:display",
    "distance:display"
  ],
  "LO-SAN": [
    "contract:display",
    "depertureAgency:display",
    "distance:display"
  ],

  "MO-DEP": [
    "vehicle:display",
    "holderId:display",
    "distance:display",
    "subscriber:display"
  ],
  "MO-HAB": [
    "holderId:display",
    "distance:display",
    "subscriber:display"
  ],
  "MO-MOB": [
    "holderId:display",
    "distance:display",
    "subscriber:display"
  ],
  "MO-SAN": [
    "holderId:display",
    "distance:display",
    "subscriber:display"
  ],

  "SA-DEP": [
    "vehicle:display",
    "holderId:display",
    "distance:display",
    "subscriber:display"
  ],
  "SA-HAB": [
    "holderId:display",
    "distance:display",
    "subscriber:display"
  ],
  "SA-MOB": [
    "holderId:display",
    "distance:display",
    "subscriber:display"
  ],
  "SA-SAN": [
    "holderId:display",
    "healthData:display",
    "distance:display",
    "subscriber:display"
  ],

};

export default rules;